import { all, fork } from "redux-saga/effects"

//public
import clientsSaga from "./clients/saga"
import popupSaga from "./popup/saga"
import AuthSaga from "./auth/login/saga"
import ForgetSaga from "./auth/forgetpwd/saga"
import ProfileSaga from "./profile/saga"
import LayoutSaga from "./layout/saga"
import peopleSaga from "./people/saga"
import experiencesSaga from "./experiences/saga"
import onboardingFlowSaga from "./onboardingFlow/saga"
import menuFeaturesSaga from "./menuFeatures/saga"
import domainsSaga from "./domains/saga"
import businessUnitsSaga from "./businessUnits/saga"

import basicContentSaga from "./menuFeatures/BasicContent/saga"
import bookingsSaga from "./menuFeatures/Bookings/saga"
import calendarEventsSaga from "./menuFeatures/CalendarEvents/saga"
import commentBoardSaga from "./menuFeatures/CommentBoard/saga"
import countdownClockSaga from "./menuFeatures/CountdownClock/saga"
import documentSaga from "./menuFeatures/Document/saga"
import eventInfoSaga from "./menuFeatures/EventInfo/saga"
import formBuilderSaga from "./menuFeatures/FormBuilder/saga"
import leaderboardSaga from "./menuFeatures/Leaderboard/saga"
import listSaga from "./menuFeatures/List/saga"
import mediaGallerySaga from "./menuFeatures/MediaGallery/saga"
import placesSaga from "./menuFeatures/Places/saga"
import pollSaga from "./menuFeatures/Poll/saga"
import privateMessageSaga from "./menuFeatures/PrivateMessage/saga"
import questionnaireSaga from "./menuFeatures/Questionnaire/saga"
import referFriendSaga from "./menuFeatures/ReferFriend/saga"
import surveySaga from "./menuFeatures/Survey/saga"
import triviaChallengeSaga from "./menuFeatures/TriviaChallenge/saga"
import webLinkSaga from "./menuFeatures/WebLink/saga"
import videoCallSaga from "./menuFeatures/VideoCall/saga"

import communicationsSaga from "./communications/saga"

import tagsSaga from "./tags/saga"
import landingScreenSaga from "./landingScreen/saga"
import listScreenSaga from "./listScreen/saga"
import contactUsScreenSaga from "./contactUsScreen/saga"
import platformSettingsSaga from "./platformSettings/saga"
import visitorsSaga from "./visitors/saga"
import placesListSaga from "./places/saga"
import categoriesSaga from "./categories/saga"
import bookingsFeatureSaga from "./bookings/saga"
import eventsSaga from "./events/saga"
import productsAndSubscriptionsSaga from "./productsAndSubscriptions/saga"
import siteUsersSaga from "./siteUsers/saga"
import rolesSaga from "./roles/saga"
import permissionsSaga from "./permissions/saga"
import payoutsSaga from "./payouts/saga"
import codesSaga from "./codes/saga"
import analyticsSaga from "./analytics/saga"
import downloadsSaga from "./downloads/saga"
import inboxSaga from "./inbox/saga"
import axisCareSaga from "./axiscare/saga"

export default function* rootSaga() {
  yield all([
    //public
    fork(AuthSaga),
    ProfileSaga(),
    ForgetSaga(),
    LayoutSaga(),
    fork(clientsSaga),
    fork(popupSaga),
    fork(peopleSaga),
    fork(experiencesSaga),
    fork(onboardingFlowSaga),
    fork(menuFeaturesSaga),
    domainsSaga,
    businessUnitsSaga,
    fork(basicContentSaga),
    fork(bookingsSaga),
    fork(calendarEventsSaga),
    fork(commentBoardSaga),
    fork(countdownClockSaga),
    fork(documentSaga),
    fork(eventInfoSaga),
    fork(formBuilderSaga),
    fork(leaderboardSaga),
    fork(listSaga),
    fork(mediaGallerySaga),
    fork(placesSaga),
    fork(pollSaga),
    fork(privateMessageSaga),
    fork(questionnaireSaga),
    fork(referFriendSaga),
    fork(surveySaga),
    fork(triviaChallengeSaga),
    fork(webLinkSaga),
    fork(communicationsSaga),
    fork(tagsSaga),
    fork(landingScreenSaga),
    fork(listScreenSaga),
    fork(contactUsScreenSaga),
    fork(platformSettingsSaga),
    fork(visitorsSaga),
    fork(placesListSaga),
    fork(categoriesSaga),
    fork(bookingsFeatureSaga),
    fork(eventsSaga),
    fork(productsAndSubscriptionsSaga),
    fork(siteUsersSaga),
    fork(rolesSaga),
    fork(permissionsSaga),
    fork(payoutsSaga),
    fork(codesSaga),
    fork(analyticsSaga),
    fork(videoCallSaga),
    fork(downloadsSaga),
    fork(inboxSaga),
    fork(axisCareSaga)
  ])
}
